function initFetchProducts() {
	const grid = document.querySelector('.projects-list');
	const viewMoreBtn = document.querySelector('.view-more-btn');

	const PER_PAGE = 15;

	// Read initial values from datasets if available
	let currentPage = parseInt(grid?.dataset.currentPage || '1', 10);
	let maxPages = parseInt(grid?.dataset.maxPages || '1', 10);

	/* -------------------------
	 * Get query variables
	 * ------------------------- */
	function getQueryParams() {
		const params = new URLSearchParams(window.location.search);

		// Taxonomies
		const taxonomies = [
			...document.querySelectorAll(
				'.filter-options input[type="checkbox"]'
			),
		]
			.map((cb) => cb.name.replace('[]', ''))
			.filter((v, i, arr) => arr.indexOf(v) === i);

		const filters = {};

		taxonomies.forEach((tax) => {
			filters[tax] = params.getAll(`${tax}[]`);
		});

		// Category
		const category =
			document.querySelector('.category-link[data-active="true"]')
				?.dataset.category || '';

		// Page
		const page = parseInt(params.get('page') || '1', 10);

		return { category, filters, page };
	}

	/* -------------------------
	 * Dispatch query-change event
	 * ------------------------- */
	function dispatchQueryChangeEvent() {
		window.dispatchEvent(
			new CustomEvent('queryVariableChanged', {
				detail: { params: new URLSearchParams(window.location.search) },
			})
		);
	}

	/* -------------------------
	 * Update URL params
	 * Include page only if > 1
	 * ------------------------- */
	function updateQueryParams() {
		const params = new URLSearchParams();

		// Collect checked values for each taxonomy
		const taxonomies = [
			...document.querySelectorAll(
				'.filter-options input[type="checkbox"]'
			),
		]
			.map((cb) => cb.name.replace('[]', ''))
			.filter((v, i, arr) => arr.indexOf(v) === i);

		taxonomies.forEach((tax) => {
			const values = [
				...document.querySelectorAll(`input[name="${tax}[]"]:checked`),
			].map((cb) => cb.value);

			values.forEach((v) => params.append(`${tax}[]`, v));
		});

		// Page only when > 1
		if (currentPage > 1) {
			params.set('page', currentPage);
		}

		const url = `${window.location.pathname}?${params.toString()}`;
		window.history.replaceState({}, '', url);

		dispatchQueryChangeEvent();
	}

	/* -------------------------
	 * Clear all query params
	 * ------------------------- */
	function clearAllQueryParams() {
		const url = new URL(window.location);
		url.search = '';
		history.replaceState({}, '', url);
		dispatchQueryChangeEvent();
	}

	/* -------------------------
	 * Fetch products via AJAX
	 * pageAppend = false → replace
	 * pageAppend = true → append
	 * ------------------------- */
	function fetchProjects(pageAppend = false) {
		const { category, filters } = getQueryParams();

		viewMoreBtn.disabled = true;
		grid.dataset.loading = 'true';

		const data = new FormData();
		data.append('action', 'filter_projects');
		data.append('category', category);

		// Taxonomies
		Object.entries(filters).forEach(([tax, values]) => {
			values.forEach((v) => data.append(`${tax}[]`, v));
		});

		data.append('page', currentPage);
		data.append('perPage', PER_PAGE);

		fetch(ajaxurl, { method: 'POST', body: data })
			.then((res) => res.json())
			.then((json) => {
				if (!json.success) {
					grid.dataset.loading = 'false';
					viewMoreBtn.disabled = false;
					console.log('Error in fetching posts');
					console.log(json);
					return;
				}

				const { content, current_page, max_pages } = json.data;

				// Update pagination
				currentPage = current_page;
				maxPages = max_pages;

				// Update dataset values on the grid
				grid.dataset.currentPage = currentPage;
				grid.dataset.maxPages = maxPages;

				// Insert content
				if (!pageAppend) grid.innerHTML = content;
				else grid.insertAdjacentHTML('beforeend', content);

				grid.dataset.loading = 'false';
				viewMoreBtn.disabled = false;

				// Update URL
				updateQueryParams();

				// Toggle "View More"
				if (currentPage >= maxPages) {
					viewMoreBtn?.classList.add('hidden');
				} else {
					viewMoreBtn?.classList.remove('hidden');
				}
			});
	}

	/* -------------------------
	 * Checkbox filters
	 * ------------------------- */
	document
		.querySelectorAll('.filter-options input[type="checkbox"]')
		.forEach((cb) => {
			cb.addEventListener('change', () => {
				currentPage = 1;
				updateQueryParams();
				fetchProjects(false);
			});
		});

	/* -------------------------
	 * Reset ALL filters
	 * ------------------------- */
	const resetButton = document.querySelector('.filter-dropdown .filter-all');
	if (resetButton) {
		resetButton.addEventListener('click', () => {
			document
				.querySelectorAll('.filter-options input[type="checkbox"]')
				.forEach((cb) => (cb.checked = false));

			currentPage = 1;

			clearAllQueryParams();
			fetchProjects(false);
		});
	}

	/* -------------------------
	 * Listen for query var change and update reset ALL button
	 * ------------------------- */
	window.addEventListener('queryVariableChanged', () => {
		const params = new URLSearchParams(window.location.search);

		const clearAllTagsButton = document.querySelector(
			'.filter-dropdown button.filter-toggle.filter-all'
		);
		if (!clearAllTagsButton) return;

		const taxParams = Array.from(params.keys()).filter((key) =>
			key.endsWith('[]')
		);

		const hasFilters = taxParams.some(
			(key) => params.getAll(key).length > 0
		);

		clearAllTagsButton.dataset.active = hasFilters ? 'false' : 'true';
	});

	/* -------------------------
	 * Dropdown toggles
	 * ------------------------- */
	document
		.querySelectorAll('.filter-dropdown > button.filter-toggle')
		.forEach((btn) => {
			btn.addEventListener('click', () => {
				document
					.querySelectorAll(
						'.filter-dropdown > button.filter-toggle[aria-expanded="true"]'
					)
					.forEach((openBtn) => {
						if (openBtn !== btn) openBtn.ariaExpanded = 'false';
					});

				btn.ariaExpanded =
					btn.ariaExpanded === 'true' ? 'false' : 'true';
			});
		});

	/* -------------------------
	 * "View More"
	 * ------------------------- */
	if (viewMoreBtn) {
		viewMoreBtn.addEventListener('click', () => {
			if (currentPage < maxPages) {
				currentPage++;
				fetchProjects(true);
			}
		});
	}
}

document.addEventListener('DOMContentLoaded', initFetchProducts);
